var _rect, _path, _g, _rect2, _rect3, _path2, _g2, _rect4, _rect5, _path3, _g3, _rect6, _rect7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3ColGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 111,
    viewBox: "0 0 156 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7174_39850)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 110,
    transform: "translate(0 0.562378)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7174_39850)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_7174_39850)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7174_39850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -12,
    y: 31,
    width: 73,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.4091 31.7557H-10.4091C-11.0116 31.7557 -11.5 32.2382 -11.5 32.8334V67.3188C-11.5 67.914 -11.0116 68.3965 -10.4091 68.3965H59.4091C60.0116 68.3965 60.5 67.914 60.5 67.3188V32.8334C60.5 32.2382 60.0116 31.7557 59.4091 31.7557Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7174_39850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4091 31.7557H-10.4091C-11.0116 31.7557 -11.5 32.2382 -11.5 32.8334V67.3188C-11.5 67.914 -11.0116 68.3965 -10.4091 68.3965H59.4091C60.0116 68.3965 60.5 67.914 60.5 67.3188V32.8334C60.5 32.2382 60.0116 31.7557 59.4091 31.7557Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M48.0654 55.2125C50.9988 55.2489 61.6221 62.2521 65.1101 63.0546C68.5984 63.857 67.4886 68.4892 67.4886 68.4892H11.2805C11.2805 68.4892 31.0206 57.8022 33.3199 58.3494C35.6188 58.8965 35.3017 60.1366 37.2835 60.1731C39.2657 60.2096 45.1323 55.1761 48.0654 55.2125Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.746174 50.1814C-2.62999 50.2317 -9.45245 59.8885 -11.6927 60.9951C-13.9329 62.1017 -13.2201 68.4892 -13.2201 68.4892H22.8779C22.8779 68.4892 10.2003 53.7525 8.72379 54.507C7.24728 55.2614 7.45103 56.9714 6.17815 57.0217C4.90524 57.072 1.13764 50.1312 -0.746174 50.1814Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8661 58.7864C46.9821 58.813 40.1596 63.9311 37.9196 64.5175C35.6792 65.104 36.3919 68.4892 36.3919 68.4892H72.4901C72.4901 68.4892 59.8123 60.679 58.3359 61.0789C56.8596 61.4787 57.0632 62.385 55.7905 62.4116C54.5174 62.4383 50.7498 58.7598 48.8661 58.7864Z",
    fill: "#D9D9D9"
  }))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 12.5,
    y: 71.5579,
    width: 22,
    height: 3.6416,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 12.5,
    y: 76.8762,
    width: 31.1896,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_7174_39850)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_7174_39850)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7174_39850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 31,
    width: 73,
    height: 38
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.409 31.7557H36.5909C35.9884 31.7557 35.5 32.2382 35.5 32.8334V67.3188C35.5 67.914 35.9884 68.3965 36.5909 68.3965H106.409C107.012 68.3965 107.5 67.914 107.5 67.3188V32.8334C107.5 32.2382 107.012 31.7557 106.409 31.7557Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7174_39850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.409 31.7557H36.5909C35.9884 31.7557 35.5 32.2382 35.5 32.8334V67.3188C35.5 67.914 35.9884 68.3965 36.5909 68.3965H106.409C107.012 68.3965 107.5 67.914 107.5 67.3188V32.8334C107.5 32.2382 107.012 31.7557 106.409 31.7557Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M95.0654 55.2125C97.9988 55.2489 108.622 62.2521 112.11 63.0546C115.598 63.857 114.489 68.4892 114.489 68.4892H58.2805C58.2805 68.4892 78.0206 57.8022 80.3199 58.3494C82.6188 58.8965 82.3017 60.1366 84.2835 60.1731C86.2657 60.2096 92.1323 55.1761 95.0654 55.2125Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2538 50.1814C44.37 50.2317 37.5476 59.8885 35.3073 60.9951C33.0671 62.1017 33.7799 68.4892 33.7799 68.4892H69.8779C69.8779 68.4892 57.2003 53.7525 55.7238 54.507C54.2473 55.2614 54.451 56.9714 53.1782 57.0217C51.9052 57.072 48.1376 50.1312 46.2538 50.1814Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8661 58.7864C93.9821 58.813 87.1596 63.9311 84.9196 64.5175C82.6792 65.104 83.3919 68.4892 83.3919 68.4892H119.49C119.49 68.4892 106.812 60.679 105.336 61.0789C103.86 61.4787 104.063 62.385 102.79 62.4116C101.517 62.4383 97.7498 58.7598 95.8661 58.7864Z",
    fill: "#D9D9D9"
  }))))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 59.5,
    y: 71.5579,
    width: 22,
    height: 3.6416,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 59.5,
    y: 76.8762,
    width: 31.1896,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_7174_39850)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_7174_39850)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7174_39850",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 82,
    y: 31,
    width: 73,
    height: 38
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.409 31.7557H83.5909C82.9884 31.7557 82.5 32.2382 82.5 32.8334V67.3188C82.5 67.914 82.9884 68.3965 83.5909 68.3965H153.409C154.012 68.3965 154.5 67.914 154.5 67.3188V32.8334C154.5 32.2382 154.012 31.7557 153.409 31.7557Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7174_39850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.409 31.7557H83.5909C82.9884 31.7557 82.5 32.2382 82.5 32.8334V67.3188C82.5 67.914 82.9884 68.3965 83.5909 68.3965H153.409C154.012 68.3965 154.5 67.914 154.5 67.3188V32.8334C154.5 32.2382 154.012 31.7557 153.409 31.7557Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M142.065 55.2125C144.999 55.2489 155.622 62.2521 159.11 63.0546C162.598 63.857 161.489 68.4892 161.489 68.4892H105.281C105.281 68.4892 125.021 57.8022 127.32 58.3494C129.619 58.8965 129.302 60.1366 131.284 60.1731C133.266 60.2096 139.132 55.1761 142.065 55.2125Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2538 50.1814C91.37 50.2317 84.5476 59.8885 82.3073 60.9951C80.0671 62.1017 80.7799 68.4892 80.7799 68.4892H116.878C116.878 68.4892 104.2 53.7525 102.724 54.507C101.247 55.2614 101.451 56.9714 100.178 57.0217C98.9052 57.072 95.1376 50.1312 93.2538 50.1814Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.866 58.7864C140.982 58.813 134.16 63.9311 131.92 64.5175C129.679 65.104 130.392 68.4892 130.392 68.4892H166.49C166.49 68.4892 153.812 60.679 152.336 61.0789C150.86 61.4787 151.063 62.385 149.79 62.4116C148.517 62.4383 144.75 58.7598 142.866 58.7864Z",
    fill: "#D9D9D9"
  }))))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 106.5,
    y: 71.5579,
    width: 22,
    height: 3.6416,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 106.5,
    y: 76.8762,
    width: 31.1896,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7174_39850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 110,
    fill: "white",
    transform: "translate(0 0.562378)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7174_39850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(12.5 31.5762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_7174_39850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 37,
    fill: "white",
    transform: "translate(-11.5 31.5762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_7174_39850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(59.5 31.5762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_7174_39850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 37,
    fill: "white",
    transform: "translate(35.5 31.5762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_7174_39850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(106.5 31.5762)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_7174_39850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 37,
    fill: "white",
    transform: "translate(82.5 31.5762)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3ColGrid);
export default __webpack_public_path__ + "static/media/3-col-grid.74664e2b713fe7c46266dfe77b3dec4f.svg";
export { ForwardRef as ReactComponent };